var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "refuse" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("Input", {
        staticClass: "ref_input",
        attrs: {
          type: "textarea",
          autosize: { minRows: 2, maxRows: 5 },
          placeholder: "Enter something...",
        },
        model: {
          value: _vm.inputValue,
          callback: function ($$v) {
            _vm.inputValue = $$v
          },
          expression: "inputValue",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pop-btn" },
        [
          _c(
            "Button",
            { staticClass: "cancel-btn", on: { click: _vm.cancel } },
            [_c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))])]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              staticClass: "sav-btn",
              attrs: { type: "error" },
              on: { click: _vm.save },
            },
            [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", [_vm._v("*")]),
      _vm._v("\n    请输入财务拒回原因:\n  "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }